module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/room_icon-6d49bcd814d0e25c44df683ec51ca603.png";